module.exports = [{"componentChunkName":"component---src-pages-404-tsx","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-tsx","jsonName":"404.json","path":"/404/"},{"componentChunkName":"component---src-pages-index-tsx","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-tsx","jsonName":"index.json","path":"/"},{"componentChunkName":"component---src-pages-404-tsx","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-tsx","jsonName":"404-html.json","path":"/404.html"}]


//////////////////
// WEBPACK FOOTER
// ./.cache/pages.json
// module id = 304
// module chunks = 231608221292675